/** Text inside a \\ce{...} block before the caret. */
export const getCeBodyBeforeCursor = (
  latexBeforeCursor: string
): string | null => {
  const openMatch = latexBeforeCursor.match(/\\ce\{([^}]*)$/)
  if (openMatch) return openMatch[1]

  const closedMatch = latexBeforeCursor.match(/\\ce\{([^}]*)\}$/)
  return closedMatch ? closedMatch[1] : null
}

/** mhchem body before caret — supports plain-text or legacy \\ce-wrapped values. */
export const getChemistryBodyBeforeCursor = (
  latexBeforeCursor: string,
  fullValue: string
): string | null => {
  const wrapped = getCeBodyBeforeCursor(latexBeforeCursor)
  if (wrapped !== null) return wrapped

  if (!/\\ce\{/.test(fullValue) && !/\\pu\{/.test(fullValue)) {
    return latexBeforeCursor
  }

  return getCeBodyBeforeCursor(fullValue)
}

/**
 * mhchem treats + immediately after an element letter or closing bracket as
 * charge (Na+). Spaced + is a reaction operator (2H2 + O2).
 */
export const shouldUseIonChargePlus = (bodyBefore: string): boolean => {
  if (!bodyBefore) return false
  const last = bodyBefore.slice(-1)
  return /[A-Za-z)\]]$/.test(last)
}

export const getPlusInsertForChemistry = (bodyBefore: string): string => {
  if (shouldUseIonChargePlus(bodyBefore)) return "+"
  if (!bodyBefore || bodyBefore.endsWith(" ")) return "+ "
  return " + "
}
